import { useState } from "react";
import { getBulkCampaignObjectsPaginated } from "V2.0/services/bulkCampaign";

export default function useBulkCampaignObjectsPaginated(
  workspaceId,
  bulkCampaignId
) {
  const [bulkCampaignObjects, setBulkCampaignObjects] = useState({
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      limit: 10,
      hasNextPage: false,
      hasPreviousPage: false,
      nextPage: null,
      previousPage: null,
    },
    isLoading: true,
  });

  async function fetchBulkCampaignObjectsPaginated(
    page = 1,
    isLoading = false
  ) {
    if (isLoading) {
      setBulkCampaignObjects((prevState) => {
        return {
          data: [...prevState.data],
          pagination: {
            ...prevState.pagination,
          },
          isLoading,
        };
      });
    }

    const params = {
      page,
      limit: bulkCampaignObjects.pagination.limit,
      // Show the most-recently-called contact at the top: each call/status change bumps the
      // campaign's updatedAt, so sorting by updatedAt desc keeps the latest activity on top and
      // pushes older ones down. The backend default (createdAt) is identical for every contact in a
      // bulk upload, so it gave no meaningful order.
      sortBy: "updatedAt",
      sortOrder: "desc",
    };
    try {
      const response = await getBulkCampaignObjectsPaginated({
        workspaceId,
        bulkCampaignId,
        params,
      });

      if (response.status === 200) {
        setBulkCampaignObjects({
          data: response.data.campaigns,
          pagination: {
            ...response.data.pagination,
          },
          isLoading: false,
        });
      }
    } catch (e) {
      setBulkCampaignObjects((prevData) => {
        return {
          data: [...prevData.data],
          pagination: {
            ...prevData.pagination,
          },
          isLoading: false,
        };
      });
    }
  }

  return {
    bulkCampaignObjects: bulkCampaignObjects.data,
    bulkCampaignObjectsPagination: bulkCampaignObjects.pagination,
    isBulkCampaignObjectsLoading: bulkCampaignObjects.isLoading,
    fetchBulkCampaignObjectsPaginated,
  };
}
